import { Heading1 } from 'components/shared/Typography';
import styled from 'styled-components';
import {
  color,
  container,
  fontFamily,
  fontSize,
  fontWeight,
  screen,
  spacing
} from 'theme';
import { getPublicPath } from 'utils/paths';

export const StyledHero = styled.div`
  background-image: ${() =>
    `url('${getPublicPath('/images/stateOfHiring/hero-bg-sm.svg')}')`};
  background-size: cover;
  background-position: bottom center;
  padding: ${spacing('xl4')} ${spacing('md')} ${spacing('xl6')};
  position: relative;

  @media (min-width: ${screen('md')}) {
    background-image: ${() =>
      `url('${getPublicPath('/images/stateOfHiring/hero-bg.svg')}')`};
    padding-top: ${spacing('xl6')};
    padding-bottom: ${spacing('xl7')};
  }
`;

export const StyledHeroContainer = styled.div`
  max-width: ${container('lg')};
  margin: auto;
  text-align: center;
  color: ${color('text_white')};
  line-height: 1.5;

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('lg')};
    line-height: 1.4;
  }
`;

export const StyledHeroTitle = styled(Heading1)`
  color: ${color('cyan_300')};
  margin-bottom: ${spacing('lg')};
  display: flex;
  flex-direction: column;
  gap: ${spacing('xs')};
  font-size: ${fontSize('xl5')};

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('xl6')};
  }

  @media (min-width: ${screen('lg')}) {
    font-size: ${fontSize('xl7')};
  }

  span {
    font-family: ${fontFamily('sans')};
    font-size: ${fontSize('md')};
    line-height: 1;
    color: ${color('text_white')};
    text-transform: uppercase;
    font-weight: ${fontWeight('extraBold')};
    letter-spacing: 0.35em;

    @media (min-width: ${screen('md')}) {
      font-size: ${fontSize('lg')};
    }
  }
`;
